




























import {Vue, Component, Prop, Watch, Mixins} from "vue-property-decorator";
import FormGroup from "@/components/ui/forms/FormGroup.vue";
import { CommentRequest, Comment } from "../services/blog.service";
import { ApiResponse, HashMap } from "../services/base.service";
import { User } from "../services/auth.service";
import NotificationMixin from "../mixins/NotificationMixin";
import MarkdownEditor from "@/components/ui/MarkdownEditor.vue";

export type CommentPost = (req: CommentRequest) => Promise<ApiResponse<any, HashMap<string>>>;

@Component({
    components: {
        FormGroup,
        MarkdownEditor,
    }
})
export default class CommentDisplay extends Mixins(NotificationMixin) {
    @Prop()
    public parentComment!: Comment;

    @Prop({type: Boolean, default: false})
    public canCancel!: boolean;

    @Prop()
    public post!: CommentPost;

    @Prop()
    public user!: User;

    private errors: HashMap<string> = {};
    private request!: CommentRequest;
    private loading: boolean = false;

    private reset() {
        this.errors = {};
        this.request = {
            body: "",
        }

        if (this.user) {
            this.request.authorId = this.user.id;
        } else {
            this.request.authorName = "";
            this.request.authorEmail = "";
        }

        if (this.parentComment) {
            this.request.parentCommentId = this.parentComment.id;
        }
    }

    private async submit() {
        this.loading = true;
        const res = await this.post(this.request);
        this.loading = false;

        if (res.success === true) {
            this.reset();
            this.$forceUpdate();
            this.notifySuccess("Comment added successfully");
            this.$emit('update');
        } else {
            this.errors = res.error;
            this.notifyError("Failed to leave comment");
        }
    }

    private created() {
        this.reset();
    }
}
